const GRID_EXPERIMENTAL_ENABLED = false;
export {
  GRID_EXPERIMENTAL_ENABLED
};
//# sourceMappingURL=envConstants.es.js.map
